import { useContext } from "react";
import { Card, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { authContext } from "../../context/AuthContext";
import DoctorDiagnosticoColombia from "../doctor/DoctorDiagnosticoColombia";
import DoctorEstudioImagenColombia from "../doctor/DoctorEstudioImagenColombia";
import DoctorIncapacidadColombia from "../doctor/DoctorIncapacidadColombia";
import DoctorLaboratorioColombia from "../doctor/DoctorLaboratorioColombia";
import DoctorReceta from "../doctor/DoctorReceta";
import DoctorRecomendacionMedicaColombia from "../doctor/DoctorRecomendacionMedicaColombia";
import DoctorRemisionesColombia from "../doctor/DoctorRemisionesColombia";
import DoctorAdditionalNotes from "../doctor/DoctorAdditionalNotes";

function CardActionRightMedicalColombia({t, cita, setValidDiagnostico, showEncuesta}){
    const {auth} = useContext(authContext)
    console.log(cita)
    return (
        <Card className="shadow-1">
            <Card.Body>
                <Tabs defaultActiveKey="receta" className="tabs-conference" transition={false}>
                    <Tab eventKey="receta" title={t('receta')}>
                        <DoctorReceta
                            appointmentReceta={cita?.receta}
                            citaID={cita.id}
                            auth={auth}
                            cita={cita}
                        />
                    </Tab>
                    <Tab eventKey="diagnostico" title={t('diagnostico')}>
                        <DoctorDiagnosticoColombia
                            citaID={ cita.id }
                            auth={ auth } 
                            disease={ cita?.diseaseList }
                            idSpeciality={Number(cita?.speciality.id)}
                            setValidDiagnostico={setValidDiagnostico}
                            cita={cita}
                        />
                    </Tab>
                    <Tab eventKey="incapacidad" title={t('incapacidad')}>
                        <DoctorIncapacidadColombia 
                            citaID={ cita.id }
                            pacienteID={cita?.patientDTO?.id}
                            auth={ auth } 
                            incapacidad={ cita?.disability }
                            showEncuesta={showEncuesta}
                        />
                    </Tab>
                    <Tab eventKey="medicalRecomendacion" title={t('recomendacion_medica')}>
                        <DoctorRecomendacionMedicaColombia 
                            citaID={ cita.id }
                            auth={ auth } 
                            medicalRecommendation={ cita?.medicalRecommendation }
                            cita={cita}
                        />
                    </Tab>
                    <Tab eventKey="remisiones" title={t('remisiones')}>
                        <DoctorRemisionesColombia 
                            citaID={ cita.id }
                            auth={ auth } 
                            remisiones={ cita?.ordenRemisiones }
                            cita={cita}
                        />
                    </Tab>
                    <Tab eventKey="estudio" title={t('estudios_imagenologicos')}>
                        <DoctorEstudioImagenColombia 
                            citaID={ cita.id }
                            auth={ auth } 
                            estudiosImagenelogicos={ cita?.estudioImagenologicos }
                            cita={cita}
                        />
                    </Tab>
                    <Tab eventKey="laboratorios" title={t('laboratorios')}>
                        <DoctorLaboratorioColombia 
                            citaID={ cita.id }
                            auth={ auth } 
                            ordenLaboratorios={ cita?.ordenLaboratorios }
                            cita={cita}
                        />
                    </Tab>
                    <Tab eventKey="additionalNotes" title="Notas aclaratoria">
                        <DoctorAdditionalNotes
                            citaID={ cita.id }
                            auth={ auth }
                            additionalNotes={ cita?.additionalNotes }
                            cita={cita}
                        />
                    </Tab>
                </Tabs>
            </Card.Body>
        </Card>
    )

}

export default withTranslation()(CardActionRightMedicalColombia)